import { render } from "./Nav.vue?vue&type=template&id=d088370c&scoped=true"
const script = {}

import "./Nav.vue?vue&type=style&index=0&id=d088370c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d088370c"

export default script